module.exports = __webpack_public_path__ + "img/UOB.35a6a24b.png";